/**
 * Sends a Google Analytics 4 `select_item` event when a visitor clicks a
 * product card, so GA4 shows which products get clicked and from where.
 *
 * Shopify's Google integration already sends view_item, view_cart and
 * purchase, but nothing for a click on a product in a list, so this fills that
 * gap. It only uses the page's existing gtag(), so it follows the same consent
 * settings as the rest of the tracking, and does nothing if gtag isn't there.
 *
 * Product data comes from the card's data-analytics-item attribute, written by
 * snippets/analytics-item.liquid.
 */
(function () {
  // Same set of elements product-card.js's navigateToProduct ignores: a click on
  // one of these (quick add, swatches, carousel arrows) doesn't open the product.
  var INTERACTIVE = 'button, input, label, select, [tabindex="1"]';

  function slugify(text) {
    return text
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function pageLabel() {
    var path = window.location.pathname;
    if (path === '/' || path === '') return 'Homepage';
    if (path.indexOf('/collections/') === 0) return 'Collection: ' + path.split('/')[2];
    if (path.indexOf('/products') === 0) return 'Product page';
    if (path.indexOf('/search') === 0) return 'Search results';
    if (path.indexOf('/cart') === 0) return 'Cart';
    if (path.indexOf('/blogs') === 0) return 'Blog';
    return 'Page';
  }

  /** Where the card is shown, e.g. "Homepage – Izdvojeni proizvodi". */
  function listOf(card) {
    if (card.closest('predictive-search-component, .search-modal__content')) {
      return { name: 'Search suggestions', scope: document };
    }

    var section = card.closest('.shopify-section') || document;
    // First heading a visitor can actually see (a section can start with a
    // visually-hidden one, like the collection page's "Aktivni filteri:"), and
    // that isn't a product's own title inside a card.
    var headings = Array.prototype.slice.call(section.querySelectorAll('h1, h2, h3'));
    var heading = headings.filter(function (h) {
      return !h.closest('.visually-hidden, [data-analytics-item]') && h.textContent.trim();
    })[0];
    var title = heading && heading.textContent.replace(/\s+/g, ' ').trim();
    var name = title ? pageLabel() + ' – ' + title.slice(0, 80) : pageLabel();
    return { name: name, scope: section };
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;

      var card = target.closest('[data-analytics-item]');
      if (!card || card.hasAttribute('data-no-navigation')) return;
      if (target.closest(INTERACTIVE)) return;
      if (typeof window.gtag !== 'function') return;

      var item;
      try {
        item = JSON.parse(card.getAttribute('data-analytics-item'));
      } catch (error) {
        return;
      }

      var list = listOf(card);
      var cards = Array.prototype.slice.call(list.scope.querySelectorAll('[data-analytics-item]'));
      item.index = cards.indexOf(card) + 1;

      window.gtag('event', 'select_item', {
        item_list_id: slugify(list.name),
        item_list_name: list.name,
        items: [item],
        // The page is about to navigate away; a beacon survives that.
        transport_type: 'beacon',
      });
    },
    true
  );
})();
